import { useEffect } from "react";
import { SITE_URL, MEDIA } from "../config/site";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Dependency-free head manager: title, description, canonical, Open Graph,
 * Twitter card and JSON-LD structured data. Cleans up injected JSON-LD on unmount.
 */
export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || MEDIA.hero;

  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertCanonical(url);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", "AeroVaid Aviation Academy");
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
    const nodes = blocks.map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });

    window.scrollTo(0, 0);

    return () => nodes.forEach((n) => n.remove());
  }, [title, description, url, ogImage, jsonLd]);

  return null;
}
